<template>
  <div class="selectOption">
    <!-- {{selectDate}} class="input_bgc"-->
    <Select v-model="selectDate" placeholder="请选择" >
      <Option
        v-for="(_item, index) in item.value.dropDownOptions"
        :key="index"
        :value="_item.name"
      >{{_item.name}}</option>
    </Select>
    <!-- <cube-select
      v-model="selectDate"
      @picker-show="picketShow"
      @picker-hide="pickerHide"
      :options="options"
      @change="changeOption"
      class="input_bgc"
    ></cube-select> -->
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      selectDate: "",
      options: [],
      placeholder: "请选择"
    };
  },
  created: function() {
    // 查看答案默认值
    if (this.item.value.dropDownAttribute.answer !== "") {
      // this.selectDate = this.item.value.dropDownAttribute.answer

      this.item.value.dropDownOptions.map((i, index) => {
        this.options.push(i.name);
      });
      this.$nextTick(() => {
        this.selectDate = this.item.value.dropDownAttribute.answer;
      });
      // console.log(this.options);
      // console.log(this.selectDate);
    } else {
      // 初始默认值
      this.item.value.dropDownOptions.map((i, index) => {
        if (i.defaultValue) {
          this.selectDate = String(i.name);
        }
        this.options.push(i.name);
      });
      // console.log(this.options);
    }
  },
  watch: {
    selectDate: function(val) {
      this.item.value.dropDownAttribute.answer = val;
      // console.log( this.item.value.dropDownAttribute.answer)
      this.$emit("selectDate", this.item.value.dropDownAttribute.answer);
    }
  },
  methods: {
    changeOption: function(value, index, text) {
      // console.log(value, index, text);
    },
    picketShow: function() {
      if (this.$store.state.brower === "pc") {
        var domStyle = document.querySelectorAll(".cube-picker");
        domStyle.forEach(item => {
          item.style.width = "30%";
          item.style.marginLeft = "35%";
        });
      }
    },
    pickerHide: function() {
      if (this.$store.state.brower === "pc") {
        var domStyle = document.querySelectorAll(".cube-picker");
        domStyle.forEach(item => {
          item.style.width = "30%";
          item.style.marginLeft = "35%";
        });
      }
    }
  }
};
</script>
<style lang="less">
.selectOption {
  width: 200px;
}
</style>


